<style scoped >
.week-active { border-top: solid 3px #2196f3 !important; margin-top:-2px; }
</style>
<template>
<v-card tile :flat='flat' height='100%' >
  <!-- <v-btn absolute small fab top right
    @click='get'
    :loading='request.loading' >
    <v-icon>replay</v-icon>
  </v-btn> -->
  <v-list v-if='withTitle' dark class='pa-0' >
    <practitioner-list-item
      :item='practitioner' >
      <v-list-tile-action v-if='request.loading' slot='action' >
        <v-progress-circular indeterminate width='2' color='amber' />
      </v-list-tile-action>
      <template slot='actions' >
        <slot name='actions' ></slot>
      </template>
    </practitioner-list-item>
  </v-list>
  <v-system-bar v-if='withDateBar && dateFormatted' class='overline' >
    <v-spacer/>
    {{dateFormatted}}
  </v-system-bar>
  <v-toolbar v-if='withWeek' dense class='pa-0' >
    <v-layout >
      <v-btn class='pr-3' @click='moveWeek(-1)' icon flat ><v-icon>chevron_left</v-icon></v-btn>
      <v-flex
        v-for='(day,index) in week' :key='index'
        class='week-day'
        :class="{ 'blue lighten-4 week-active': (day.format('YYYY-MM-DD') === date) }"
        @click='$emit("update:date", day.format("YYYY-MM-DD"))' >
        <center>
        <small class='overline' >{{ day.format('ddd') }}</small><br/>
        {{ day.format('D') }}
        </center>
      </v-flex>
      <v-btn class='pl-3' @click='moveWeek(1)' icon flat ><v-icon>chevron_right</v-icon></v-btn>
    </v-layout>
  </v-toolbar>
  <v-divider/>
  <v-card flat>
    <v-btn v-if='withAdd' @click='slotSelected' absolute fab top right small >
      <v-icon>add</v-icon>
    </v-btn>
    <!-- E: {{events.length}} -->
  <day-view class='ml-1' :flat='flat'
    v-if='date && practitionerId'
    @dayview:createevent='slotSelected'
    @dayview:multiselect='multiselect'
    :pixel-to-minute-ratio='settings.density || 1'
    :readOnly='isNotMe'
    :date='date' :with-fetch='false'
    :start-hour='settings.startHour'
    :end-hour='settings.endHour'
    :default-new-event-length='settings.defaultNewEventLength'
    :selected-appointment='selectedAppointment'
    :preview-event='previewEvent'
    :events='events' >
  </day-view>
  <v-divider />
  </v-card>
</v-card>
</template>
<script>
import {SET_SETTING} from '@/store/constants'
import DayView from '@/components/calendar/DayView'
import CalendarMixins from './CalendarMixins.js'
import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'
import moment from 'moment'

export default {
  name: 'PractitionerDayView',
  mixins: [CalendarMixins],
  components: {DayView, PractitionerListItem},
  props: {
    practitioner: {type: Object, required: true},
    settings: {type: Object, required: false, default: () => { return {} }},
    date: { type: String, required: true },
    withTitle: { type: Boolean, default: false },
    withDateBar: { type: Boolean, default: false },
    blockEvents: { type: Boolean, default: false },
    withAdd: { type: Boolean, default: false },
    withFetch: { type: Boolean, default: false },
    withWeek: { type: Boolean, default: false },
    hideCancelled: { type: Boolean, default: true },
    flat: { type: Boolean, default: true },
    touch: { type: Number, default: 0 },
    filterSpaces: { type: Array, default: () => { return [] } },
    filterLocations: { type: Array, default: () => { return [] } },
    selectedAppointment: { type: Object, required: false },
    previewEvent: { type: Object, required: false }
  },
  data () {
    return {
      request: {
        resource: 'ag.practitioner.appointments'
      }
    }
  },
  mounted () {
    if (this.withFetch) {
      this.get()
    }
  },
  computed: {
    practitionerId () {
      return this.getObjectPath(this.practitioner, 'id', null)
    },
    dateFormatted () {
      if (this.date) {
        return moment(this.date).format('ddd D MMM YYYY')
      }
      return null
    },
    week () {
      moment.updateLocale('en', {week: { dow: 1 }})
      if (this.withWeek && this.date) {
        let dt = moment(this.date)
        let days = []
        let wkEnd = moment(dt.endOf('week'))
        let currentDate = moment(dt.startOf('week'))
        while (currentDate.isSameOrBefore(wkEnd)) {
          let day = currentDate.format('YYYY-MM-DD')
          days.push(moment(day))
          currentDate = moment(currentDate).add(1, 'days')
        }
        return days
      }
      return null
    },
    events () {
      // must slice it so as to be dealing with a copy - might fix that random infinite render loop problem
      let evts = this.$store.getters.getCalendarDay(this.practitionerId, this.date).slice()
      // console.log(evts)
      return evts.filter((evt) => {
        if (this.hideCancelled) {
          if (evt.status === 'C') { return false }
        }
        if (this.filterSpaces && this.filterSpaces.length > 0) {
          if (this.filterSpaces.indexOf(evt.space) === -1) {
            return false
          }
        }
        if (this.filterLocations && this.filterLocations.length > 0) {
          if (this.filterLocations.indexOf(evt.address_id) === -1) {
            return false
          }
        }
        return true
      })
      // if (this.filterSpaces && this.filterSpaces.length > 0) {
      //   evts = evts.filter((evt) => {
      //     return this.filterSpaces.indexOf(evt.space) !== -1
      //   })
      // }
      // if (this.filterLocations && this.filterLocations.length > 0) {
      //   evts = evts.filter((evt) => {
      //     return this.filterLocations.indexOf(evt.address_id) !== -1
      //   })
      // }
    },
    watchString () {
      return this.practitionerId + this.date + this.touch
    },
    isNotMe () {
      return this.practitionerId !== this.me.id
    },
    requestStatus () {
      return this.request.status
    }
  },
  watch: {
    watchString () {
      if (this.withFetch) { this.get() }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        let events = this.getObjectPath(this.request, 'result.results', [])
        events = this.formatEvents(events)
        this.$store.commit('addAppointments', events)
      }
    }
  },
  methods: {
    multiselect (appointment) {
      if (this.blockEvents) {
        this.$emit('multiselect', appointment)
      } else {
        this.$store.commit('toggleGloballySelectedAppointment', appointment)
      }
    },
    moveWeek (numWeeks) {
      let newDate = moment(this.date).add(numWeeks, 'weeks').format('YYYY-MM-DD')
      this.$emit('update:date', newDate)
    },
    slotSelected (slot) {
      this.$emit('slotSelected', slot)
      this.$emit('dayview:createevent', slot)
      if (this.blockEvents) { return null }

      // open create appointment dialog:
      let vm = this
      let startTime = moment(this.date)
      if (slot && slot.start_time) {
        startTime = slot.start_time
      }
      this.openGlobalDialog(true, 'QuickCreate')
      setTimeout(() => {
        vm.$store.commit(SET_SETTING, ['startTime', startTime])
        vm.$store.commit(SET_SETTING, ['activePractitioner', vm.practitioner])
      }, 500)
    },
    get () {
      if (this.practitionerId) {
        let params = {
          before_utc: this.date,
          after_utc: this.date,
          practitioner: this.practitionerId
        }
        this.request.params = params
        return this.$request('get', this.request)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PractitionerDayView.vue?0b0ef1d0